import config from 'config';

export function getLandingUrlFromLocation(location: Location): Location['origin'] {
  const domains: string[] = config.get('public.cookie.domains');

  if (!domains.find((domain) => location.hostname.endsWith(domain))) {
    throw new Error(`Location hostname ${location.hostname} is not whitelisted in (${domains})`);
  }

  return location.origin;
}
